module.exports = __webpack_public_path__ + "static/img/img_gy_e_f.0a016094.png";